<div *ngIf="descriptor" [formGroup]="form">

    <div [formArrayName]="descriptor.controlName" class="vedrax-matrix-pb-15">

        <mat-accordion>

            <ng-container *ngFor="let control of formArray.controls; let i = index;">


                <mat-expansion-panel *ngIf="getControlValue(control, 'visible')">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{getControlValue(control, 'key')}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <p *ngFor="let entry of getChildControls(control, 'entries').controls; let y = index;">
                        <mat-form-field appearance="outline">
                            <mat-label>{{getControlValue(entry, 'key')}}</mat-label>
                            <input type="number" required matInput [formControl]="getChildControl(entry, 'value')">
                        </mat-form-field>
                    </p>

                </mat-expansion-panel>

            </ng-container>

        </mat-accordion>

    </div>

</div>